class HeroSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.hero-slider__track');
    this.slides = [...el.querySelectorAll('.hero-slide')];
    this.dots = [...el.querySelectorAll('.hero-slider__dot')];
    this.prevBtn = el.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = el.querySelector('.hero-slider__arrow--next');
    this.toggleBtn = el.querySelector('.hero-slider__toggle');
    this.current = 0;
    this.total = this.slides.length;
    this.autoplaySpeed = parseInt(el.dataset.autoplay || 5) * 1000;
    this.timer = null;
    this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.init();
  }

  init() {
    this.goTo(0);
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute('aria-pressed', this.userPaused);
      this.toggleBtn.addEventListener('click', () => this.togglePause());
    }
    this.startAutoplay();

    // Pause on hover and while keyboard focus is inside the slider
    this.el.addEventListener('mouseenter', () => { this.hovered = true; this.stopAutoplay(); });
    this.el.addEventListener('mouseleave', () => { this.hovered = false; this.startAutoplay(); });
    this.el.addEventListener('focusin', () => { this.focused = true; this.stopAutoplay(); });
    this.el.addEventListener('focusout', (e) => {
      if (this.el.contains(e.relatedTarget)) return;
      this.focused = false;
      this.startAutoplay();
    });

    // Touch swipe
    this.addSwipe();
  }

  goTo(index) {
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current]?.classList.remove('is-active');

    this.current = (index + this.total) % this.total;

    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.slides[this.current].classList.add('is-active');
    this.dots[this.current]?.classList.add('is-active');

    // Keep off-screen slides out of the tab order and away from screen readers
    this.slides.forEach((slide, i) => { slide.inert = i !== this.current; });
    this.dots.forEach((dot, i) => {
      if (i === this.current) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  next() { this.goTo(this.current + 1); this.resetAutoplay(); }
  prev() { this.goTo(this.current - 1); this.resetAutoplay(); }

  startAutoplay() {
    if (this.total < 2 || this.userPaused || this.hovered || this.focused) return;
    this.stopAutoplay();
    this.timer = setInterval(() => this.next(), this.autoplaySpeed);
  }

  togglePause() {
    this.userPaused = !this.userPaused;
    this.toggleBtn.setAttribute('aria-pressed', this.userPaused);
    if (this.userPaused) this.stopAutoplay();
    else this.startAutoplay();
  }

  stopAutoplay() { clearInterval(this.timer); }
  resetAutoplay() { this.stopAutoplay(); this.startAutoplay(); }

  addSwipe() {
    let startX = 0;
    this.el.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    this.el.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) diff > 0 ? this.next() : this.prev();
    });
  }
}

document.querySelectorAll('.hero-slider').forEach(el => new HeroSlider(el));